import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/multi-domain-website-framework/multi-domain-website-framework/apps/nippon-center-pakistan/src/components/ApplyModal.tsx");
